import { Modal, ModalProps } from 'components/common'

type CustomizedModalProps = Omit<
  ModalProps,
  'title' | 'okType' | 'okText' | 'okButtonProps' | 'cancelText'
>
export interface ProductVariationsDeleteConfirmModalProps
  extends CustomizedModalProps {
  variantName: string
}
export const ProductVariationsDeleteConfirmModal = ({
  variantName,
  ...rest
}: ProductVariationsDeleteConfirmModalProps): JSX.Element => (
  <>
    <Modal
      title={`${variantName} を削除しますか？`}
      okText={'バリエーションを削除する'}
      okType={'primary'}
      okButtonProps={{ danger: true }}
      cancelText={'キャンセル'}
      {...rest}
    >
      {` バリエーション ${variantName} を削除してもよろしいですか？
      削除後元に戻すことはできません。`}
    </Modal>
  </>
)
